import { render } from "./subheader-datasets.vue?vue&type=template&id=037b35fa"
import script from "./subheader-datasets.vue?vue&type=script&lang=js"
export * from "./subheader-datasets.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__